import { Component, OnInit } from '@angular/core';
import { CFHttpClient } from '../../shared/cf-http-client';
import { Router, ActivatedRoute } from '@angular/router';
import { UserSession } from '../../shared/user-session';
import { HolisticMemberProfileService } from '@mem-shared/holistic-member-profile.service';
import { EventService } from 'app/shared/event.service';
import { MemberAttributes, HolisticMemberProfile, MemberFeatureFlags } from '../holistic-profile';
import { NativeIntegrationService } from '@mem-shared/native-integration.service';
import { UtilService } from '@mem-shared/util.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { error } from 'selenium-webdriver';
import { debug } from 'util';

const memberProfileUrl = '/mas/sec/getHolisticMemberProfile.json';
const DATA_LOADED_EVENT_NAME = 'ON_DATA_LOADED';
const MemberCommunicationInfo = '/mas/sec/getMemberCommunicationInfo.json'


@Component({
  selector: 'mem-fetch-user-data',
  templateUrl: './fetch-user-data.component.html',
  styleUrls: ['./fetch-user-data.component.scss']
})

export class FetchUserDataComponent implements OnInit {
  memberHolisticProfile: HolisticMemberProfile;
  dlContent: string[];
  loading: boolean;
  constructor(
    private httpClient: CFHttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private userSession: UserSession,
    private httpService: HttpClient,
    private nativeService: NativeIntegrationService,
    public utilSvc: UtilService,
    private holisticMemberProfileService: HolisticMemberProfileService,
    private eventService: EventService
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      if (data.detail) {
        this.userSession.setMemberAccountDetails(data.detail);
        const memberAccountDetails = data.detail.memberAccountDetails;
        
        //line adde for check for  member login through ebiz
        if (memberAccountDetails.length === 1) {
          this.userSession.setCurrentAccountId(memberAccountDetails[0].accountId);
        }
        // Commenting the below code to fix cookie issue
        // else if (this.userSession.getCookie('accountId')) { // if cookie exisits
        //   this.userSession.setCurrentAccountId(this.userSession.getCookie('accountId'));
        // }
        else {
          this.router.navigateByUrl('/multipleAccounts');
          return;
        }
      }
      else if (this.userSession.getMemberAccountDetails()) {

      }
      if(this.userSession.getMemberAccountDetails().ImpersonationStatus){
        this.userSession.setLocalStorageItem('isEbizAdmin',this.userSession.getMemberAccountDetails().ImpersonationStatus.impersonation)
      }
      //delay loading profile while redirection from MOS
      // if (this.utilSvc.getNativeOS() === 'Android') {
      //   this.setloadingTimeOut();
      // }
      this.getMemberCommunicationInfo();
      //this.loadHolisticProfile();
     
     

    });
  }

  getMemberCommunicationInfo() {
    console.log(this.userSession.getLocalStorageItem('isEbizAdmin'))
    this.httpClient.get(MemberCommunicationInfo).subscribe(
      data => {
        this.userSession.promoPageTaken = true;
        console.log('MemberCommunicationInfo :____ ', data);
        this.userSession.setLocalStorageItem('communicationAndConsentDetails', JSON.stringify(data.communicationAndConsentDetails))
        console.log(data.communicationAndConsentDetails.emailCommunicationInfo.primaryEmailInfo.emailStatusCode);
        if (data.communicationAndConsentDetails.emailCommunicationInfo.primaryEmailInfo.emailStatusCode == 'Confirmed') {
          // if (data.communicationAndConsentDetails.emailCommunicationInfo.secondaryEmailInfo.emailStatusCode == 'Confirmed') {
          //delay loading profile while redirection from MOS
          //   alert('Email verified');
          if (this.utilSvc.getNativeOS() === 'Android') {
            this.setloadingTimeOut();
          }
          this.loadHolisticProfile();
        }
        else {
          if(this.userSession.getLocalStorageItem('isEbizAdmin')!='true'){
          this.router.navigateByUrl('/login/KeepAccountSafe');
          return;
        } else{
          this.loadHolisticProfile();
        }          
        }

      },
      error => {
        console.log(error);
      }
    );
  }

  setloadingTimeOut() {
    setTimeout(() => {
      this.loading = false;
    }, 10000);
  }

  isNativeDevice() {
    var origin = window.location.origin;
    if (origin.indexOf('file:/') !== -1) {
      return true;
    } else {
      return false;
    }
  }

  loadHolisticProfile() {
    if (!this.userSession.isDataLoaded) {
      this.httpClient.get(memberProfileUrl).subscribe(
        data => {
          this.userSession.setMemberProfile(data);
          // setting account Id cookie
          this.userSession.setCookie('accountId', this.userSession.getCurrentAccountId());
          const url = this.userSession.deeplinkUrl;
          this.holisticMemberProfileService.setClientFlags();
          if (this.isNativeDevice()) {
            this.memberHolisticProfile = this.userSession.getMemberProfile();
            var params = this.userSession.getCurrentAccountId() + "," +
              this.memberHolisticProfile.memberKey.subscriberId + "," +
              this.memberHolisticProfile.memberKey.relationship + "," +
              this.nativeService.loggingInUserName + "," +
              this.nativeService.loggingInPassword + "," +
              this.memberHolisticProfile.memberKey.firstName + " " +
              this.memberHolisticProfile.memberKey.lastName + "," +
              this.memberHolisticProfile.memberAttributes.subscriberFirstName + " " +
              this.memberHolisticProfile.memberAttributes.subscriberLastName;
            this.nativeService.invokeNativeService(this.utilSvc.getNativeOS(), 'pushUserInfo', String(params));

            // Dynamic Deeplink changes
            this.httpService.get('assets/native-app-static/deeplink-config.json').subscribe
              (

              data => {
                //  alert('In loadHolisticProfile deeplink.config.json ');
                // alert(data);
                //    console.log('In loadHolisticProfile deeplink.config.json ');
                console.log(data);
                this.dlContent = data as string[];	 // FILL THE ARRAY WITH DATA.
                this.callNativeSvc(this.dlContent);
              },
              (err: HttpErrorResponse) => {
                //console.log ("**** Deeplink native call error *** "+err.message);
              }
              );
          }


          this.eventService.publish(DATA_LOADED_EVENT_NAME, this.userSession.isDataLoaded);
          if (url) {
            this.userSession.deeplinkUrl = null;
            this.router.navigate([url]);
          } else {
            // we should put home/landing page as default
            this.router.navigate(['/landing']);
          }

          if (this.isNativeDevice()) {
            this.memberHolisticProfile = this.userSession.getMemberProfile();
            // alert(this.memberHolisticProfile.memberFeatureFlags.needStepUpAuth)
            if (url == "/landing" && !this.memberHolisticProfile.memberFeatureFlags.needStepUpAuth) {
              this.nativeService.invokeNativeService(this.utilSvc.getNativeOS(), 'getDeepLinkURL', String(params));
            }
          }
        },
        error => {
          this.router.navigate(['/error']);
        }
      );
    }
  }

  callNativeSvc(dlContent) {
    //  alert('in callNativeSvc');
    if (dlContent) {
      var filteredFlags = [];
      var memberFeatureFlags = Object.entries(this.memberHolisticProfile.memberFeatureFlags);
      memberFeatureFlags.forEach(element => {
        filteredFlags.push(element[0]);
      });
      var flagNameList = [];
      var touchItemsList = [];
      var touchList = dlContent[0].touch;
      var widgetList = dlContent[0].widget;
      widgetList.forEach(item => {
        if (item.flagName) {
          if (this.findItemInArray(filteredFlags, item.flagName)) {
            flagNameList.push(item);
          }
        }
      });

      touchList.forEach(item => {
        if (item.flagName) {
          if (this.findItemInArray(filteredFlags, item.flagName)) {
            touchItemsList.push(item);
          }
        }
      });

      var deeplink = {
        widgets: flagNameList,
        touchItems: touchItemsList
      };

      //Please make sure the data is populated correctly in json format. Else native application will be unable to 
      //update the widgets properly.
      console.log("**** dynamicDeeplinkParam native call() ****");
      this.nativeService.invokeNativeService(this.utilSvc.getNativeOS(), "dynamicDeeplinkParam", JSON.stringify(deeplink));
    }
    else {
    }
  }

  findItemInArray(arrayToSearch: string[], item: string) {
    var counter = 0;
    if (!arrayToSearch || arrayToSearch.length == 0) {
      return false;
    }
    for (var i = 0; i < arrayToSearch.length; i++) {
      if (arrayToSearch[i] == item) {
        return true;
      } else {
        counter++;
      }
    }
    if (arrayToSearch.length == counter) {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/fetch-user-data/fetch-user-data.component.ts